export { default as Img200 } from './processed/200/Johnny-English-Strikes-Again.jpg';
export { default as Img400 } from './processed/400/Johnny-English-Strikes-Again.jpg';
export { default as Imgthumb } from './processed/thumb/Johnny-English-Strikes-Again.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Johnny-English-Strikes-Again.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Johnny-English-Strikes-Again.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      193,
      30,
      27
    ],
    "_population": 196,
    "_hsl": [
      0.003012048192771084,
      0.7545454545454546,
      0.4313725490196078
    ]
  },
  "LightVibrant": {
    "_rgb": [
      232,
      189,
      162
    ],
    "_population": 901,
    "_hsl": [
      0.06428571428571432,
      0.6034482758620688,
      0.7725490196078431
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      104,
      52,
      36
    ],
    "_population": 2,
    "_hsl": [
      0.0392156862745098,
      0.48571428571428565,
      0.27450980392156865
    ]
  },
  "Muted": {
    "_rgb": [
      178,
      114,
      97
    ],
    "_population": 231,
    "_hsl": [
      0.03497942386831278,
      0.34468085106382973,
      0.5392156862745098
    ]
  },
  "LightMuted": {
    "_rgb": [
      217,
      201,
      193
    ],
    "_population": 267,
    "_hsl": [
      0.05555555555555555,
      0.24000000000000005,
      0.803921568627451
    ]
  },
  "DarkMuted": {
    "_rgb": [
      57,
      62,
      74
    ],
    "_population": 772,
    "_hsl": [
      0.6176470588235294,
      0.12977099236641224,
      0.25686274509803925
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Johnny-English-Strikes-Again.js